export const facialRecognition = {
  'All right!': 'Tudo certo!',
  'We’ve confirmed your identity! You can keep enjoying a hair-free life with us!':
    'Confirmamos sua identidade! Você pode continuar a aproveitar uma vida livre de pelos conosco!',
  'Hi, {{name}}!': 'Olá, {{name}}!',
  'We identified {{count}} absence(s)/cancellation(s) with less than 24h notice in your last {{analyzed}} appointments (limit: {{limit}}).':
    'Identificamos {{count}} falta(s)/cancelamento(s) com menos de 24h nos seus últimos {{analyzed}} agendamentos (limite: {{limit}}).',
  'Because of that, this unit is temporarily unable to schedule new appointments for you.':
    'Por isso, esta unidade está temporariamente impedida de agendar novos atendimentos para você.',
  'To keep scheduling with us, we need to confirm your identity through facial recognition. It only takes a few seconds.':
    'Para continuar agendando conosco, precisamos confirmar sua identidade através do reconhecimento facial. Leva só alguns segundos.',
  'The facial recognition confirms that it is you requesting this new appointment, and that you are aware of and agree to attend.':
    'O reconhecimento facial confirma que é você mesmo solicitando este novo agendamento, e que está ciente e de acordo em comparecer.',
  Continue: 'Prosseguir',
};
